import React, { useState } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
import { applyReasons } from '../constant/loan';
const CstInfoModal = () => {
    const {
        LoanStore: {
            amount,
            applyReason,
            cstInfoModalVisible,
            closeCstInfoModal,
            updateData,
            apply,
            collateralStockUIList,
            applyDisabled,
            getLendBusinessTime,
            transType,
        },
        AuthStore: {
            collectionDeliveryBankAccountName,
            collectionDeliveryBankAccountCode,
            collectionDeliveryBankAccount,
            interestRate,
            deadLine,
            updateUserInfo,
        },
    } = useStore();

    const cstArr = collateralStockUIList.filter(cst => cst.cstQty > 0);
    const cstAmount = cstArr.reduce(
        (preVal, curVal) => preVal + curVal.cstQty,
        0
    );
    const [isClicked, setIsClicked] = useState(true);
    return (
        <Modal
            show={cstInfoModalVisible}
            onHide={closeCstInfoModal}
            title={'確認借款資料'}
        >
            <form
                onSubmit={async e => {
                    e.preventDefault();
                    updateData('applyDisabled', true);
                    const loanSwitch = await getLendBusinessTime();
                    if (loanSwitch) {
                        closeCstInfoModal();
                        if (
                            transType === 'E1' ||
                            transType === 'E2' ||
                            transType === 'E3'
                        ) {
                            updateData('transInfoModalVisible', true);
                            updateData('applyDisabled', true);
                        } else {
                            updateData('transInfoModalVisible', false);
                            updateData('applyDisabled', false);
                            updateData(
                                'amount',
                                removeNonNumeric(
                                    Math.floor(amount / 1000) * 1000
                                )
                            );
                            await apply();
                            updateUserInfo();
                        }
                    } else {
                        closeCstInfoModal();
                    }
                }}
            >
                <h4 className="title fw-bolder mb-2">請您確認以下申請資料</h4>
                <ul className="apply-info scrol-opacity table-responsive d-flex flex-nowrap justify-content-between align-items-end text-center mb-2">
                    <li className="px-1 pt-2 pb-1 order-3 order-md-0">
                        <h6 className="red fs-15">
                            {applyReasons
                                .filter(i => i.value === applyReason)
                                .map(i => i.label)}
                        </h6>
                        <small className="fs-12">借款目的</small>
                    </li>
                    <li className="px-1 pt-2 pb-1 position-relative">
                        <h6 className="red">
                            <span>{interestRate}</span>%
                        </h6>
                        <small className="fs-12">適用利率</small>
                    </li>
                    <li className="px-1 pt-2 pb-1">
                        <h6 className="red fs-15">{deadLine}</h6>
                        <small className="fs-12">借款到期日</small>
                    </li>
                </ul>
                <h5 className="title fw-bolder mb-2">使用以下庫存作為擔保品</h5>
                <div className="stock-inv d-flex flex-nowrap justify-content-between align-items-center px-3  px-md-2 pt-2 pb-1  mb-4">
                    <div className="stock-scrol col-9 col-sm-10 table-responsive-lg">
                        {cstArr.map((cst, idx) => {
                            return (
                                <div
                                    key={`LoanCst ${idx}`}
                                    className="stock-card text-center rounded-2 bg-white fs-12 me-2 mb-1 float-start"
                                >
                                    <div className="stock-name text-black2 p-2">
                                        <span>{cst.stockName}</span>
                                        <small className="gray-light ms-1">
                                            {cst.stockNo}
                                        </small>
                                    </div>
                                    <div className="stock-number text-white rounded-bottom ">
                                        {cst.cstQty}
                                        <small>張</small>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="fs-15 text-center col-3 col-sm-2">
                        合計<b className="num text-orange mx-1">{cstAmount}</b>
                        張
                    </div>
                </div>

                <div className="formbox row g-4">
                    <div className="col-12">
                        <label className="form-label">轉入帳戶</label>
                        <li className="position-relative ">
                            <input
                                type="text"
                                className="form-control"
                                value={collectionDeliveryBankAccountName}
                                disabled
                            />
                        </li>
                    </div>
                    <div className="col-12">
                        <label className="form-label">銀行帳號</label>
                        <li className="position-relative">
                            <input
                                type="text"
                                className="form-control"
                                value={`${collectionDeliveryBankAccountCode}-${collectionDeliveryBankAccount}`}
                                disabled
                            />
                        </li>
                    </div>
                    <div className="col-12">
                        <label className="form-label">借款金額</label>
                        <li className="red-num position-relative">
                            <span className="fw-bolder position-absolute">
                                $
                            </span>
                            <input
                                type="text"
                                className="form-control fw-bolder"
                                value={addCommas(
                                    removeNonNumeric(
                                        Math.floor(
                                            removeCommas(amount) / 1000
                                        ) * 1000
                                    )
                                )}
                                disabled
                            />
                        </li>
                    </div>
                </div>
                <p className="text-danger text-start  fs-12 mt-2">
                    請確認申請資料，送出申請後則無法修改銀行帳號和金額
                </p>
                <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                    <button
                        className="btn_cancel btn rounded-pill  text-sm-center"
                        type="button"
                        onClick={() => {
                            updateData('loanCstModalVisible', true);
                            closeCstInfoModal();
                        }}
                    >
                        想換擔保品
                    </button>
                    <button
                        className="btn_check btn rounded-pill text-white"
                        type="submit"
                        disabled={applyDisabled}
                    >
                        確認申請
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default observer(CstInfoModal);
